import { enqueueSlice } from 'src/store/enqueue/reducers';

export const COMMIT_SEARCH_PARAMS =
  enqueueSlice.actions.commitSearchParams.type;
